import { ActionType } from "@ms/uno-actions/lib/local/ActionType";
/** A tuple of the supported ActionType values for NewsBarStore, for use in the registry */ export const NewsBarStoreActionTypes = [
    ActionType.DismissNewsBarAction,
    ActionType.ShowNewsBarAction
];
